// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteV1BusinessPartnerCurrentIcon, deleteV1DomainById, deleteV1IdentityCurrentInviteToJoinById, deleteV1IdentityCurrentRequestToJoinById, deleteV1IdentityCurrentUserById, deleteV1IdentityProviderById, deleteV1InviteToJoinById, deleteV1OauthClientById, deleteV1RequestToJoinById, deleteV1UserById, getV1BusinessPartnerCurrent, getV1BusinessPartnerCurrentDivisions, getV1BusinessPartnerCurrentProfiles, getV1BusinessPartnerCurrentSuggestIdentities, getV1BusinessPartnerCurrentWithCurrentIdentityInfo, getV1Context, getV1DomainById, getV1Domains, getV1Identities, getV1IdentityCurrent, getV1IdentityCurrentBusinessPartners, getV1IdentityCurrentInvitesToJoin, getV1IdentityCurrentRequestsToJoin, getV1IdentityCurrentRequestToJoinById, getV1IdentityCurrentUsers, getV1IdentityProviderById, getV1IdentityProviders, getV1InvitesToJoin, getV1InviteToJoinById, getV1OauthClientById, getV1OauthClients, getV1OauthClientsCategories, getV1RequestsToJoin, getV1RequestToJoinById, getV1RolesCurrent, getV1UserById, getV1UserCurrent, getV1UserCurrentApps, getV1UserCurrentOauthClients, getV1Users, type Options, postV1BusinessPartnerCurrentIcon, postV1Domain, postV1IdentityCurrentInviteToJoinByIdAccept, postV1IdentityProvider, postV1InviteToJoin, postV1OauthClient, postV1OauthClientByIdIcon, postV1RequestToJoin, postV1SupportToken, postV1User, putV1BusinessPartnerCurrent, putV1DomainById, putV1DomainByIdVerify, putV1IdentityCurrent, putV1IdentityProviderById, putV1InviteToJoinById, putV1OauthClientById, putV1UserById } from '../sdk.gen';
import type { DeleteV1BusinessPartnerCurrentIconData, DeleteV1BusinessPartnerCurrentIconResponse, DeleteV1DomainByIdData, DeleteV1IdentityCurrentInviteToJoinByIdData, DeleteV1IdentityCurrentInviteToJoinByIdResponse, DeleteV1IdentityCurrentRequestToJoinByIdData, DeleteV1IdentityCurrentRequestToJoinByIdResponse, DeleteV1IdentityCurrentUserByIdData, DeleteV1IdentityCurrentUserByIdResponse, DeleteV1IdentityProviderByIdData, DeleteV1InviteToJoinByIdData, DeleteV1OauthClientByIdData, DeleteV1RequestToJoinByIdData, DeleteV1UserByIdData, DeleteV1UserByIdResponse, GetV1BusinessPartnerCurrentData, GetV1BusinessPartnerCurrentDivisionsData, GetV1BusinessPartnerCurrentDivisionsResponse, GetV1BusinessPartnerCurrentProfilesData, GetV1BusinessPartnerCurrentProfilesResponse, GetV1BusinessPartnerCurrentResponse, GetV1BusinessPartnerCurrentSuggestIdentitiesData, GetV1BusinessPartnerCurrentSuggestIdentitiesResponse, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoData, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponse, GetV1ContextData, GetV1ContextResponse, GetV1DomainByIdData, GetV1DomainByIdResponse, GetV1DomainsData, GetV1DomainsResponse, GetV1IdentitiesData, GetV1IdentitiesResponse, GetV1IdentityCurrentBusinessPartnersData, GetV1IdentityCurrentBusinessPartnersResponse, GetV1IdentityCurrentData, GetV1IdentityCurrentInvitesToJoinData, GetV1IdentityCurrentInvitesToJoinResponse, GetV1IdentityCurrentRequestsToJoinData, GetV1IdentityCurrentRequestsToJoinResponse, GetV1IdentityCurrentRequestToJoinByIdData, GetV1IdentityCurrentRequestToJoinByIdResponse, GetV1IdentityCurrentResponse, GetV1IdentityCurrentUsersData, GetV1IdentityCurrentUsersResponse, GetV1IdentityProviderByIdData, GetV1IdentityProviderByIdResponse, GetV1IdentityProvidersData, GetV1IdentityProvidersResponse, GetV1InvitesToJoinData, GetV1InvitesToJoinResponse, GetV1InviteToJoinByIdData, GetV1InviteToJoinByIdResponse, GetV1OauthClientByIdData, GetV1OauthClientByIdResponse, GetV1OauthClientsCategoriesData, GetV1OauthClientsCategoriesResponse, GetV1OauthClientsData, GetV1OauthClientsResponse, GetV1RequestsToJoinData, GetV1RequestsToJoinResponse, GetV1RequestToJoinByIdData, GetV1RequestToJoinByIdResponse, GetV1RolesCurrentData, GetV1RolesCurrentResponse, GetV1UserByIdData, GetV1UserByIdResponse, GetV1UserCurrentAppsData, GetV1UserCurrentAppsResponse, GetV1UserCurrentData, GetV1UserCurrentOauthClientsData, GetV1UserCurrentOauthClientsResponse, GetV1UserCurrentResponse, GetV1UsersData, GetV1UsersResponse, PostV1BusinessPartnerCurrentIconData, PostV1DomainData, PostV1DomainResponse, PostV1IdentityCurrentInviteToJoinByIdAcceptData, PostV1IdentityCurrentInviteToJoinByIdAcceptResponse, PostV1IdentityProviderData, PostV1IdentityProviderResponse, PostV1InviteToJoinData, PostV1InviteToJoinResponse, PostV1OauthClientByIdIconData, PostV1OauthClientData, PostV1OauthClientResponse, PostV1RequestToJoinData, PostV1RequestToJoinResponse, PostV1SupportTokenData, PostV1SupportTokenResponse, PostV1UserData, PostV1UserResponse, PutV1BusinessPartnerCurrentData, PutV1BusinessPartnerCurrentResponse, PutV1DomainByIdData, PutV1DomainByIdResponse, PutV1DomainByIdVerifyData, PutV1DomainByIdVerifyResponse, PutV1IdentityCurrentData, PutV1IdentityCurrentResponse, PutV1IdentityProviderByIdData, PutV1IdentityProviderByIdResponse, PutV1InviteToJoinByIdData, PutV1InviteToJoinByIdResponse, PutV1OauthClientByIdData, PutV1OauthClientByIdResponse, PutV1UserByIdData, PutV1UserByIdResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getV1BusinessPartnerCurrentQueryKey = (options?: Options<GetV1BusinessPartnerCurrentData>) => createQueryKey('getV1BusinessPartnerCurrent', options);

/**
 * Get the current BusinessPartner
 *
 *  Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile". Include icon param to get extra information about icon.
 */
export const getV1BusinessPartnerCurrentOptions = (options?: Options<GetV1BusinessPartnerCurrentData>) => queryOptions<GetV1BusinessPartnerCurrentResponse, DefaultError, GetV1BusinessPartnerCurrentResponse, ReturnType<typeof getV1BusinessPartnerCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentQueryKey(options)
});

/**
 * Update the current BusinessPartner
 *
 *  Update the current BusinessPartner. Must have `bp_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1BusinessPartnerCurrentMutation = (options?: Partial<Options<PutV1BusinessPartnerCurrentData>>): UseMutationOptions<PutV1BusinessPartnerCurrentResponse, DefaultError, Options<PutV1BusinessPartnerCurrentData>> => {
    const mutationOptions: UseMutationOptions<PutV1BusinessPartnerCurrentResponse, DefaultError, Options<PutV1BusinessPartnerCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1BusinessPartnerCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1BusinessPartnerCurrentDivisionsQueryKey = (options?: Options<GetV1BusinessPartnerCurrentDivisionsData>) => createQueryKey('getV1BusinessPartnerCurrentDivisions', options);

/**
 * Get the divisions of the current BusinessPartner organization
 *
 *  Get the divisions of the current BusinessPartner for the current Identity, with hydrated information.  BusinessPartners which are inviteOnly are omitted from the response depending on the current User profile. Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentDivisionsOptions = (options?: Options<GetV1BusinessPartnerCurrentDivisionsData>) => queryOptions<GetV1BusinessPartnerCurrentDivisionsResponse, DefaultError, GetV1BusinessPartnerCurrentDivisionsResponse, ReturnType<typeof getV1BusinessPartnerCurrentDivisionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentDivisions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentDivisionsQueryKey(options)
});

/**
 * Delete the icon for the current business partner
 *
 *  Requires scope "topcon.ciam.pap".
 */
export const deleteV1BusinessPartnerCurrentIconMutation = (options?: Partial<Options<DeleteV1BusinessPartnerCurrentIconData>>): UseMutationOptions<DeleteV1BusinessPartnerCurrentIconResponse, DefaultError, Options<DeleteV1BusinessPartnerCurrentIconData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1BusinessPartnerCurrentIconResponse, DefaultError, Options<DeleteV1BusinessPartnerCurrentIconData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1BusinessPartnerCurrentIcon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload an icon for the current business partner
 *
 *  Post an icon for the current BusinessPartner. Must have `bp_admin` role. Post a form with `thumbnail` png or jpeg, which will be resized to 256x256 Requires scope "topcon.ciam.pap".
 */
export const postV1BusinessPartnerCurrentIconMutation = (options?: Partial<Options<PostV1BusinessPartnerCurrentIconData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1BusinessPartnerCurrentIconData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1BusinessPartnerCurrentIconData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1BusinessPartnerCurrentIcon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1BusinessPartnerCurrentProfilesQueryKey = (options?: Options<GetV1BusinessPartnerCurrentProfilesData>) => createQueryKey('getV1BusinessPartnerCurrentProfiles', options);

/**
 * Get the available profiles for the current BusinessPartner
 *
 *  Get the profiles which are available to assign Users for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentProfilesOptions = (options?: Options<GetV1BusinessPartnerCurrentProfilesData>) => queryOptions<GetV1BusinessPartnerCurrentProfilesResponse, DefaultError, GetV1BusinessPartnerCurrentProfilesResponse, ReturnType<typeof getV1BusinessPartnerCurrentProfilesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentProfiles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentProfilesQueryKey(options)
});

export const getV1BusinessPartnerCurrentSuggestIdentitiesQueryKey = (options?: Options<GetV1BusinessPartnerCurrentSuggestIdentitiesData>) => createQueryKey('getV1BusinessPartnerCurrentSuggestIdentities', options);

/**
 * Get a list of Identity which might be added to the BusinessPartner as a User
 *
 *  Suggest a list of identities whose email address domains match a registered domain of the current BusinessPartner, and are not already a User or RequestToJoin. `suggest` parameter if present must be at least 3 characters. `suggest` parameter is case insensitive contains for the username part of the email. Result set will be limited to 64 records. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentSuggestIdentitiesOptions = (options?: Options<GetV1BusinessPartnerCurrentSuggestIdentitiesData>) => queryOptions<GetV1BusinessPartnerCurrentSuggestIdentitiesResponse, DefaultError, GetV1BusinessPartnerCurrentSuggestIdentitiesResponse, ReturnType<typeof getV1BusinessPartnerCurrentSuggestIdentitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentSuggestIdentities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentSuggestIdentitiesQueryKey(options)
});

export const getV1BusinessPartnerCurrentWithCurrentIdentityInfoQueryKey = (options?: Options<GetV1BusinessPartnerCurrentWithCurrentIdentityInfoData>) => createQueryKey('getV1BusinessPartnerCurrentWithCurrentIdentityInfo', options);

/**
 * Get the current BusinessPartner
 *
 *  Requires scope "topcon.ciam.pap".
 */
export const getV1BusinessPartnerCurrentWithCurrentIdentityInfoOptions = (options?: Options<GetV1BusinessPartnerCurrentWithCurrentIdentityInfoData>) => queryOptions<GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponse, DefaultError, GetV1BusinessPartnerCurrentWithCurrentIdentityInfoResponse, ReturnType<typeof getV1BusinessPartnerCurrentWithCurrentIdentityInfoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1BusinessPartnerCurrentWithCurrentIdentityInfo({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1BusinessPartnerCurrentWithCurrentIdentityInfoQueryKey(options)
});

export const getV1ContextQueryKey = (options?: Options<GetV1ContextData>) => createQueryKey('getV1Context', options);

/**
 * Get the session context (based on the token)
 *
 *  Get information about the current session context. If the current session is a service provider (dealer) supporting a customer, the body will have a 'serviceProvider' object. If the current session is topcon supporting a dealer or customer, the body will have a 'topconSupport' object. Otherwise the body may have 'identity' and 'businessPartner' objects detailing the current identity and businessPartner respectively. The identity may be the owner or user of the businessPartner if it is not a support session. See result body schema for more information. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1ContextOptions = (options?: Options<GetV1ContextData>) => queryOptions<GetV1ContextResponse, DefaultError, GetV1ContextResponse, ReturnType<typeof getV1ContextQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Context({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1ContextQueryKey(options)
});

/**
 * Create a Domain
 *
 *  Create a Domain for a BusinessPartner.  The Domain will require validation using DNS TXT record before if can be used. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1DomainMutation = (options?: Partial<Options<PostV1DomainData>>): UseMutationOptions<PostV1DomainResponse, DefaultError, Options<PostV1DomainData>> => {
    const mutationOptions: UseMutationOptions<PostV1DomainResponse, DefaultError, Options<PostV1DomainData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Domain({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a particular Domain
 *
 *  Delete a particular Domain. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1DomainByIdMutation = (options?: Partial<Options<DeleteV1DomainByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1DomainByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1DomainByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1DomainById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1DomainByIdQueryKey = (options: Options<GetV1DomainByIdData>) => createQueryKey('getV1DomainById', options);

/**
 * Get a particular Domain
 *
 *  Get a particular Domain. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1DomainByIdOptions = (options: Options<GetV1DomainByIdData>) => queryOptions<GetV1DomainByIdResponse, DefaultError, GetV1DomainByIdResponse, ReturnType<typeof getV1DomainByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1DomainById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1DomainByIdQueryKey(options)
});

/**
 * Update a particular Domain
 *
 *  Update a particular Domain. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1DomainByIdMutation = (options?: Partial<Options<PutV1DomainByIdData>>): UseMutationOptions<PutV1DomainByIdResponse, DefaultError, Options<PutV1DomainByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1DomainByIdResponse, DefaultError, Options<PutV1DomainByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1DomainById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Verify the DNS TXT record for a Domain
 *
 *  Perform verification of the DNS TXT record and update the Domain verified status accordingly. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1DomainByIdVerifyMutation = (options?: Partial<Options<PutV1DomainByIdVerifyData>>): UseMutationOptions<PutV1DomainByIdVerifyResponse, DefaultError, Options<PutV1DomainByIdVerifyData>> => {
    const mutationOptions: UseMutationOptions<PutV1DomainByIdVerifyResponse, DefaultError, Options<PutV1DomainByIdVerifyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1DomainByIdVerify({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1DomainsQueryKey = (options?: Options<GetV1DomainsData>) => createQueryKey('getV1Domains', options);

/**
 * Get the list of Domain for the current BusinessPartner (based on the token)
 *
 *  Get the list of Domain for the current BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1DomainsOptions = (options?: Options<GetV1DomainsData>) => queryOptions<GetV1DomainsResponse, DefaultError, GetV1DomainsResponse, ReturnType<typeof getV1DomainsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Domains({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1DomainsQueryKey(options)
});

export const getV1IdentitiesQueryKey = (options?: Options<GetV1IdentitiesData>) => createQueryKey('getV1Identities', options);

/**
 * Search identities
 *
 *  Search for identities. <hr /> <br /> <br /> Supports filtering by email and name (searches across first and last name). Requires profile "topcon.customer_service.support". Requires scope "topcon.ciam.pap".
 */
export const getV1IdentitiesOptions = (options?: Options<GetV1IdentitiesData>) => queryOptions<GetV1IdentitiesResponse, DefaultError, GetV1IdentitiesResponse, ReturnType<typeof getV1IdentitiesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Identities({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentitiesQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getV1IdentitiesInfiniteQueryKey = (options?: Options<GetV1IdentitiesData>): QueryKey<Options<GetV1IdentitiesData>> => createQueryKey('getV1Identities', options, true);

/**
 * Search identities
 *
 *  Search for identities. <hr /> <br /> <br /> Supports filtering by email and name (searches across first and last name). Requires profile "topcon.customer_service.support". Requires scope "topcon.ciam.pap".
 */
export const getV1IdentitiesInfiniteOptions = (options?: Options<GetV1IdentitiesData>) => {
    const opts = infiniteQueryOptions<GetV1IdentitiesResponse, DefaultError, InfiniteData<GetV1IdentitiesResponse>, QueryKey<Options<GetV1IdentitiesData>>, number | Pick<QueryKey<Options<GetV1IdentitiesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1IdentitiesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Identities({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1IdentitiesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1IdentityCurrentQueryKey = (options?: Options<GetV1IdentityCurrentData>) => createQueryKey('getV1IdentityCurrent', options);

/**
 * Get the current Identity
 *
 *  Get the current Identity.  Set external param=true to get externalIdentities. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1IdentityCurrentOptions = (options?: Options<GetV1IdentityCurrentData>) => queryOptions<GetV1IdentityCurrentResponse, DefaultError, GetV1IdentityCurrentResponse, ReturnType<typeof getV1IdentityCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentQueryKey(options)
});

/**
 * Put the current Identity
 *
 *  Put the current Identity. Set archived true will soft delete the identity, after one week it will be deleted. Logging back in will unarchive the identity and prevent the delete. If the identity owns business partners then 409. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const putV1IdentityCurrentMutation = (options?: Partial<Options<PutV1IdentityCurrentData>>): UseMutationOptions<PutV1IdentityCurrentResponse, DefaultError, Options<PutV1IdentityCurrentData>> => {
    const mutationOptions: UseMutationOptions<PutV1IdentityCurrentResponse, DefaultError, Options<PutV1IdentityCurrentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1IdentityCurrent({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityCurrentBusinessPartnersQueryKey = (options?: Options<GetV1IdentityCurrentBusinessPartnersData>) => createQueryKey('getV1IdentityCurrentBusinessPartners', options);

/**
 * Get the BusinessPartner related to the current Identity
 *
 *  Get the business partners related in some way to the current Identity, with hydrated information. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentBusinessPartnersOptions = (options?: Options<GetV1IdentityCurrentBusinessPartnersData>) => queryOptions<GetV1IdentityCurrentBusinessPartnersResponse, DefaultError, GetV1IdentityCurrentBusinessPartnersResponse, ReturnType<typeof getV1IdentityCurrentBusinessPartnersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentBusinessPartners({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentBusinessPartnersQueryKey(options)
});

/**
 * Reject an InviteToJoin
 *
 *  Reject an InviteToJoin.  The current identity must have an email matching the email of the InviteToJoin.  Success will delete the InviteToJoin object. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityCurrentInviteToJoinByIdMutation = (options?: Partial<Options<DeleteV1IdentityCurrentInviteToJoinByIdData>>): UseMutationOptions<DeleteV1IdentityCurrentInviteToJoinByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentInviteToJoinByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1IdentityCurrentInviteToJoinByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentInviteToJoinByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1IdentityCurrentInviteToJoinById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Accept an InviteToJoin
 *
 *  Accept an InviteToJoin.  The current identity must have an email matching the email of the InviteToJoin. Success will delete the InviteToJoin object. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const postV1IdentityCurrentInviteToJoinByIdAcceptMutation = (options?: Partial<Options<PostV1IdentityCurrentInviteToJoinByIdAcceptData>>): UseMutationOptions<PostV1IdentityCurrentInviteToJoinByIdAcceptResponse, DefaultError, Options<PostV1IdentityCurrentInviteToJoinByIdAcceptData>> => {
    const mutationOptions: UseMutationOptions<PostV1IdentityCurrentInviteToJoinByIdAcceptResponse, DefaultError, Options<PostV1IdentityCurrentInviteToJoinByIdAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1IdentityCurrentInviteToJoinByIdAccept({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityCurrentInvitesToJoinQueryKey = (options?: Options<GetV1IdentityCurrentInvitesToJoinData>) => createQueryKey('getV1IdentityCurrentInvitesToJoin', options);

/**
 * Get the list of InviteToJoin for the current Identity (based on the token)
 *
 *  Get the InviteToJoin and hydrated BusinessPartner information for Invitations related to the current Identity. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentInvitesToJoinOptions = (options?: Options<GetV1IdentityCurrentInvitesToJoinData>) => queryOptions<GetV1IdentityCurrentInvitesToJoinResponse, DefaultError, GetV1IdentityCurrentInvitesToJoinResponse, ReturnType<typeof getV1IdentityCurrentInvitesToJoinQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentInvitesToJoin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentInvitesToJoinQueryKey(options)
});

/**
 * Withdraw a RequestToJoin
 *
 *  Withdraw a RequestToJoin.  Success will delete the RequestToJoin object. Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityCurrentRequestToJoinByIdMutation = (options?: Partial<Options<DeleteV1IdentityCurrentRequestToJoinByIdData>>): UseMutationOptions<DeleteV1IdentityCurrentRequestToJoinByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentRequestToJoinByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1IdentityCurrentRequestToJoinByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentRequestToJoinByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1IdentityCurrentRequestToJoinById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityCurrentRequestToJoinByIdQueryKey = (options: Options<GetV1IdentityCurrentRequestToJoinByIdData>) => createQueryKey('getV1IdentityCurrentRequestToJoinById', options);

/**
 * Get a particular RequestToJoin for the current Identity
 *
 *  Get a particular RequestToJoin for the current Identity. Includes reviewers who can approve or reject the request. Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentRequestToJoinByIdOptions = (options: Options<GetV1IdentityCurrentRequestToJoinByIdData>) => queryOptions<GetV1IdentityCurrentRequestToJoinByIdResponse, DefaultError, GetV1IdentityCurrentRequestToJoinByIdResponse, ReturnType<typeof getV1IdentityCurrentRequestToJoinByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentRequestToJoinById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentRequestToJoinByIdQueryKey(options)
});

export const getV1IdentityCurrentRequestsToJoinQueryKey = (options?: Options<GetV1IdentityCurrentRequestsToJoinData>) => createQueryKey('getV1IdentityCurrentRequestsToJoin', options);

/**
 * Get the list of RequestToJoin for the current Identity (based on the token)
 *
 *  Get the list of RequestToJoin for the current Identity. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentRequestsToJoinOptions = (options?: Options<GetV1IdentityCurrentRequestsToJoinData>) => queryOptions<GetV1IdentityCurrentRequestsToJoinResponse, DefaultError, GetV1IdentityCurrentRequestsToJoinResponse, ReturnType<typeof getV1IdentityCurrentRequestsToJoinQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentRequestsToJoin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentRequestsToJoinQueryKey(options)
});

/**
 * Leave an organization
 *
 *  Leave an organization by deleting the User record linking the current Identity to a BusinessPartner. Cannot leave if you are the owner of the BusinessPartner - transfer ownership first. If using a BP-scoped token, cannot leave the current BusinessPartner (use identity-only token for that). Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityCurrentUserByIdMutation = (options?: Partial<Options<DeleteV1IdentityCurrentUserByIdData>>): UseMutationOptions<DeleteV1IdentityCurrentUserByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentUserByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1IdentityCurrentUserByIdResponse, DefaultError, Options<DeleteV1IdentityCurrentUserByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1IdentityCurrentUserById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityCurrentUsersQueryKey = (options?: Options<GetV1IdentityCurrentUsersData>) => createQueryKey('getV1IdentityCurrentUsers', options);

/**
 * Get the list of User for the current Identity (based on the token)
 *
 *  Get the User and hydrated BusinessPartner information for User related to the current Identity. Must be an Identity-only token (switch=nobp). Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityCurrentUsersOptions = (options?: Options<GetV1IdentityCurrentUsersData>) => queryOptions<GetV1IdentityCurrentUsersResponse, DefaultError, GetV1IdentityCurrentUsersResponse, ReturnType<typeof getV1IdentityCurrentUsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityCurrentUsers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityCurrentUsersQueryKey(options)
});

/**
 * Create an IdentityProvider
 *
 *  Create an IdentityProvider for a BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1IdentityProviderMutation = (options?: Partial<Options<PostV1IdentityProviderData>>): UseMutationOptions<PostV1IdentityProviderResponse, DefaultError, Options<PostV1IdentityProviderData>> => {
    const mutationOptions: UseMutationOptions<PostV1IdentityProviderResponse, DefaultError, Options<PostV1IdentityProviderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1IdentityProvider({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a particular IdentityProvider
 *
 *  Delete a particular IdentityProvider. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1IdentityProviderByIdMutation = (options?: Partial<Options<DeleteV1IdentityProviderByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1IdentityProviderByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1IdentityProviderByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1IdentityProviderById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityProviderByIdQueryKey = (options: Options<GetV1IdentityProviderByIdData>) => createQueryKey('getV1IdentityProviderById', options);

/**
 * Get a particular IdentityProvider
 *
 *  Get a particular IdentityProvider. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityProviderByIdOptions = (options: Options<GetV1IdentityProviderByIdData>) => queryOptions<GetV1IdentityProviderByIdResponse, DefaultError, GetV1IdentityProviderByIdResponse, ReturnType<typeof getV1IdentityProviderByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityProviderById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityProviderByIdQueryKey(options)
});

/**
 * Update a particular IdentityProvider
 *
 *  Update a particular IdentityProvider. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1IdentityProviderByIdMutation = (options?: Partial<Options<PutV1IdentityProviderByIdData>>): UseMutationOptions<PutV1IdentityProviderByIdResponse, DefaultError, Options<PutV1IdentityProviderByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1IdentityProviderByIdResponse, DefaultError, Options<PutV1IdentityProviderByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1IdentityProviderById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1IdentityProvidersQueryKey = (options?: Options<GetV1IdentityProvidersData>) => createQueryKey('getV1IdentityProviders', options);

/**
 * Get the list of IdentityProvider for the current BusinessPartner (based on the token)
 *
 *  Get the list of IdentityProvider for the current BusinessPartner. Requires scope "topcon.ciam.pap".
 */
export const getV1IdentityProvidersOptions = (options?: Options<GetV1IdentityProvidersData>) => queryOptions<GetV1IdentityProvidersResponse, DefaultError, GetV1IdentityProvidersResponse, ReturnType<typeof getV1IdentityProvidersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1IdentityProviders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1IdentityProvidersQueryKey(options)
});

/**
 * Create an InviteToJoin for the current BusinessPartner (based on the token)
 *
 *  Create an InviteToJoin.  This sends an email to the invited identity with a link to login or register an identity to accept. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1InviteToJoinMutation = (options?: Partial<Options<PostV1InviteToJoinData>>): UseMutationOptions<PostV1InviteToJoinResponse, DefaultError, Options<PostV1InviteToJoinData>> => {
    const mutationOptions: UseMutationOptions<PostV1InviteToJoinResponse, DefaultError, Options<PostV1InviteToJoinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1InviteToJoin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a particular InviteToJoin
 *
 *  Delete a particular InviteToJoin.  InviteToJoin entities are also deleted when they are accepted by the Identity to which the invite was extended. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1InviteToJoinByIdMutation = (options?: Partial<Options<DeleteV1InviteToJoinByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1InviteToJoinByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1InviteToJoinByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1InviteToJoinById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1InviteToJoinByIdQueryKey = (options: Options<GetV1InviteToJoinByIdData>) => createQueryKey('getV1InviteToJoinById', options);

/**
 * Get a particular InviteToJoin
 *
 *  Get a particular InviteToJoin. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1InviteToJoinByIdOptions = (options: Options<GetV1InviteToJoinByIdData>) => queryOptions<GetV1InviteToJoinByIdResponse, DefaultError, GetV1InviteToJoinByIdResponse, ReturnType<typeof getV1InviteToJoinByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1InviteToJoinById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1InviteToJoinByIdQueryKey(options)
});

/**
 * Update a particular InviteToJoin
 *
 *  Update a particular InviteToJoin.  Updating with the same email address will result in the invitation email being resent to the invited identity. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1InviteToJoinByIdMutation = (options?: Partial<Options<PutV1InviteToJoinByIdData>>): UseMutationOptions<PutV1InviteToJoinByIdResponse, DefaultError, Options<PutV1InviteToJoinByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1InviteToJoinByIdResponse, DefaultError, Options<PutV1InviteToJoinByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1InviteToJoinById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1InvitesToJoinQueryKey = (options?: Options<GetV1InvitesToJoinData>) => createQueryKey('getV1InvitesToJoin', options);

/**
 * Get the list of InviteToJoin for the current BusinessPartner (based on the token)
 *
 *  Get the list of InviteToJoin for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1InvitesToJoinOptions = (options?: Options<GetV1InvitesToJoinData>) => queryOptions<GetV1InvitesToJoinResponse, DefaultError, GetV1InvitesToJoinResponse, ReturnType<typeof getV1InvitesToJoinQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1InvitesToJoin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1InvitesToJoinQueryKey(options)
});

/**
 * Create a Client
 *
 *  Create a Client for a BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1OauthClientMutation = (options?: Partial<Options<PostV1OauthClientData>>): UseMutationOptions<PostV1OauthClientResponse, DefaultError, Options<PostV1OauthClientData>> => {
    const mutationOptions: UseMutationOptions<PostV1OauthClientResponse, DefaultError, Options<PostV1OauthClientData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1OauthClient({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a particular Client
 *
 *  Delete a particular OAuth Client. Returns 409 Conflict if the Client is not an OAuth Client. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1OauthClientByIdMutation = (options?: Partial<Options<DeleteV1OauthClientByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1OauthClientByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1OauthClientByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1OauthClientById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1OauthClientByIdQueryKey = (options: Options<GetV1OauthClientByIdData>) => createQueryKey('getV1OauthClientById', options);

/**
 * Get a particular Client
 *
 *  Get a particular OAuth Client. Returns 409 Conflict if the Client is not an OAuth Client. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1OauthClientByIdOptions = (options: Options<GetV1OauthClientByIdData>) => queryOptions<GetV1OauthClientByIdResponse, DefaultError, GetV1OauthClientByIdResponse, ReturnType<typeof getV1OauthClientByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1OauthClientById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1OauthClientByIdQueryKey(options)
});

/**
 * Update a particular Client
 *
 *  Update a particular OAuth Client. Returns 409 Conflict if the Client is not an OAuth Client. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1OauthClientByIdMutation = (options?: Partial<Options<PutV1OauthClientByIdData>>): UseMutationOptions<PutV1OauthClientByIdResponse, DefaultError, Options<PutV1OauthClientByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1OauthClientByIdResponse, DefaultError, Options<PutV1OauthClientByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1OauthClientById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upload an icon for the stated client
 *
 *  Post an icon for the stated client. Must have `it_admin` role. Post a form with `thumbnail` png or jpeg, which will be resized to 256x256 Requires scope "topcon.ciam.pap".
 */
export const postV1OauthClientByIdIconMutation = (options?: Partial<Options<PostV1OauthClientByIdIconData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1OauthClientByIdIconData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1OauthClientByIdIconData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1OauthClientByIdIcon({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1OauthClientsQueryKey = (options?: Options<GetV1OauthClientsData>) => createQueryKey('getV1OauthClients', options);

/**
 * Get the list of Client for the current BusinessPartner (based on the token)
 *
 *  Get the list of Client for the current BusinessPartner. Must have `it_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1OauthClientsOptions = (options?: Options<GetV1OauthClientsData>) => queryOptions<GetV1OauthClientsResponse, DefaultError, GetV1OauthClientsResponse, ReturnType<typeof getV1OauthClientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1OauthClients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1OauthClientsQueryKey(options)
});

export const getV1OauthClientsCategoriesQueryKey = (options?: Options<GetV1OauthClientsCategoriesData>) => createQueryKey('getV1OauthClientsCategories', options);

/**
 * Get the list of allowed app categories
 *
 *  Get the list of allowed app categories for OAuth Clients. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1OauthClientsCategoriesOptions = (options?: Options<GetV1OauthClientsCategoriesData>) => queryOptions<GetV1OauthClientsCategoriesResponse, DefaultError, GetV1OauthClientsCategoriesResponse, ReturnType<typeof getV1OauthClientsCategoriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1OauthClientsCategories({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1OauthClientsCategoriesQueryKey(options)
});

/**
 * Create a RequestToJoin
 *
 *  Create a RequestToJoin for an identity asking to join a public or protected BusinessPartner.  This will notify User administrators of the RequestToJoin.  The current Identity (based on the token) is the requesting Identity.  The current BusinessPartner (based on the token) must be the parent of the BusinessPartner (or the bp itself) which the Identity is requesting to join. Requires scope "topcon.ciam.pap".
 */
export const postV1RequestToJoinMutation = (options?: Partial<Options<PostV1RequestToJoinData>>): UseMutationOptions<PostV1RequestToJoinResponse, DefaultError, Options<PostV1RequestToJoinData>> => {
    const mutationOptions: UseMutationOptions<PostV1RequestToJoinResponse, DefaultError, Options<PostV1RequestToJoinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1RequestToJoin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a particular RequestToJoin
 *
 *  Delete a particular RequestToJoin for the current BusinessPartner (based on the token).  This is used by administrators to reject a RequestToJoin. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1RequestToJoinByIdMutation = (options?: Partial<Options<DeleteV1RequestToJoinByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1RequestToJoinByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1RequestToJoinByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1RequestToJoinById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1RequestToJoinByIdQueryKey = (options: Options<GetV1RequestToJoinByIdData>) => createQueryKey('getV1RequestToJoinById', options);

/**
 * Get a particular RequestToJoin
 *
 *  Get a particular RequestToJoin. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1RequestToJoinByIdOptions = (options: Options<GetV1RequestToJoinByIdData>) => queryOptions<GetV1RequestToJoinByIdResponse, DefaultError, GetV1RequestToJoinByIdResponse, ReturnType<typeof getV1RequestToJoinByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RequestToJoinById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RequestToJoinByIdQueryKey(options)
});

export const getV1RequestsToJoinQueryKey = (options?: Options<GetV1RequestsToJoinData>) => createQueryKey('getV1RequestsToJoin', options);

/**
 * Get the list of RequestToJoin for the current BusinessPartner (based on the token)
 *
 *  Get the list of RequestToJoin for the current BusinessPartner.  An administrator may approve a RequestToJoin by creating a User with the same Identity id.  To reject a request, delete the RequestToJoin entity. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1RequestsToJoinOptions = (options?: Options<GetV1RequestsToJoinData>) => queryOptions<GetV1RequestsToJoinResponse, DefaultError, GetV1RequestsToJoinResponse, ReturnType<typeof getV1RequestsToJoinQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RequestsToJoin({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RequestsToJoinQueryKey(options)
});

export const getV1RolesCurrentQueryKey = (options?: Options<GetV1RolesCurrentData>) => createQueryKey('getV1RolesCurrent', options);

/**
 * Get the current roles (based on the token)
 *
 *  Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1RolesCurrentOptions = (options?: Options<GetV1RolesCurrentData>) => queryOptions<GetV1RolesCurrentResponse, DefaultError, GetV1RolesCurrentResponse, ReturnType<typeof getV1RolesCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RolesCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RolesCurrentQueryKey(options)
});

/**
 * Create a support token
 *
 *  Create a support token for Topcon customer service support. Sign-in with the email support-token@topcon.com and use a token created here to authenticate as the target identity. Must have `topcon.customer_service.support` profile. Current business partner must be type `topcon`. Must be called from the CSSD client (topcon-cssd). Requires scope "topcon.ciam.pap".
 */
export const postV1SupportTokenMutation = (options?: Partial<Options<PostV1SupportTokenData>>): UseMutationOptions<PostV1SupportTokenResponse, DefaultError, Options<PostV1SupportTokenData>> => {
    const mutationOptions: UseMutationOptions<PostV1SupportTokenResponse, DefaultError, Options<PostV1SupportTokenData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1SupportToken({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Create a User
 *
 *  Create a User for the current BusinessPartner.  The current identity cannot add themself, except the owner.  The create operation will succeed if the email domain of the Identity matches a registered domain for the BusinessPartner, or if there is a RequestToJoin for the identity. Any matching RequestToJoin is deleted. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const postV1UserMutation = (options?: Partial<Options<PostV1UserData>>): UseMutationOptions<PostV1UserResponse, DefaultError, Options<PostV1UserData>> => {
    const mutationOptions: UseMutationOptions<PostV1UserResponse, DefaultError, Options<PostV1UserData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1User({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1UserCurrentQueryKey = (options?: Options<GetV1UserCurrentData>) => createQueryKey('getV1UserCurrent', options);

/**
 * Get the current User
 *
 *  Get the current User.  The result will include a hydrated BusinessPartner and Identity. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1UserCurrentOptions = (options?: Options<GetV1UserCurrentData>) => queryOptions<GetV1UserCurrentResponse, DefaultError, GetV1UserCurrentResponse, ReturnType<typeof getV1UserCurrentQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1UserCurrent({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UserCurrentQueryKey(options)
});

export const getV1UserCurrentAppsQueryKey = (options?: Options<GetV1UserCurrentAppsData>) => createQueryKey('getV1UserCurrentApps', options);

/**
 * Get the list of apps for the current User (based on the token)
 *
 *  Get the list of apps usable by the current user. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1UserCurrentAppsOptions = (options?: Options<GetV1UserCurrentAppsData>) => queryOptions<GetV1UserCurrentAppsResponse, DefaultError, GetV1UserCurrentAppsResponse, ReturnType<typeof getV1UserCurrentAppsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1UserCurrentApps({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UserCurrentAppsQueryKey(options)
});

export const getV1UserCurrentOauthClientsQueryKey = (options?: Options<GetV1UserCurrentOauthClientsData>) => createQueryKey('getV1UserCurrentOauthClients', options);

/**
 * Get the list of apps for the current User (based on the token)
 *
 *  Deprecated: Use /v1/user/current/apps instead. Get the list of apps usable by the current user. Requires scope "topcon.ciam.pap" or "topcon.ciam.pap.profile".
 */
export const getV1UserCurrentOauthClientsOptions = (options?: Options<GetV1UserCurrentOauthClientsData>) => queryOptions<GetV1UserCurrentOauthClientsResponse, DefaultError, GetV1UserCurrentOauthClientsResponse, ReturnType<typeof getV1UserCurrentOauthClientsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1UserCurrentOauthClients({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UserCurrentOauthClientsQueryKey(options)
});

/**
 * Delete a particular User
 *
 *  Delete a User for the current BusinessPartner.  Any User may be deleted (as the owner is always an implied user). Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const deleteV1UserByIdMutation = (options?: Partial<Options<DeleteV1UserByIdData>>): UseMutationOptions<DeleteV1UserByIdResponse, DefaultError, Options<DeleteV1UserByIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1UserByIdResponse, DefaultError, Options<DeleteV1UserByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1UserById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1UserByIdQueryKey = (options: Options<GetV1UserByIdData>) => createQueryKey('getV1UserById', options);

/**
 * Get a particular User
 *
 *  Get a particular User for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1UserByIdOptions = (options: Options<GetV1UserByIdData>) => queryOptions<GetV1UserByIdResponse, DefaultError, GetV1UserByIdResponse, ReturnType<typeof getV1UserByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1UserById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UserByIdQueryKey(options)
});

/**
 * Update a particular User
 *
 *  Update a particular User for the current BusinessPartner.  A identity cannot update themself, except the owner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const putV1UserByIdMutation = (options?: Partial<Options<PutV1UserByIdData>>): UseMutationOptions<PutV1UserByIdResponse, DefaultError, Options<PutV1UserByIdData>> => {
    const mutationOptions: UseMutationOptions<PutV1UserByIdResponse, DefaultError, Options<PutV1UserByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1UserById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1UsersQueryKey = (options?: Options<GetV1UsersData>) => createQueryKey('getV1Users', options);

/**
 * Get the list of User for the current BusinessPartner (based on the token)
 *
 *  Get the Users for the current BusinessPartner.  The response will include hydrated Identity entities for each User, and an the owning identity entity for the current BusinessPartner. Must have `user_admin` role. Requires scope "topcon.ciam.pap".
 */
export const getV1UsersOptions = (options?: Options<GetV1UsersData>) => queryOptions<GetV1UsersResponse, DefaultError, GetV1UsersResponse, ReturnType<typeof getV1UsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Users({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UsersQueryKey(options)
});
